// DS: DS6.1 - Checkbox Semantics, but in a toggle pill format
import React from 'react';
import { useBiClickLogger } from '@wix/da-bi/pkg/hooks/useBiClickLogger';
import { CommonListItemAPI, useListItem } from '../../common';
import MainToggle, {
  type Props as MainToggleProps,
} from '../../../../formControls/dsPresets/MainToggle';
import ListItemContent from '../../legos/ListItemContent';
import { setRefs } from '../../../../../utils/refHelpers';

export interface Props
  extends Omit<
      MainToggleProps,
      'inputClassName' | 'className' | 'isChecked' | 'value'
    >,
    CommonListItemAPI {
  /** adds the toggle's biData (if any) to the label too */
  addBiDataToLabel?: boolean;
  className?: string;
  value?: string;
}

const ListItemToggle: React.FC<Props> = unfilteredProps => {
  const {
    rootProps: {
      className,
      innerRef,
      checked,
      name,
      value,
      biData,
      addBiDataToLabel,
      ...rest
    },
    contentProps,
    ref,
  } = useListItem<HTMLElement, Props>(unfilteredProps);

  const { setTrackingRef } = useBiClickLogger(
    addBiDataToLabel ? biData : undefined
  );
  const setLabelRefs = node => {
    setTrackingRef(node);
    setRefs([ref, innerRef], node);
  };

  return (
    <label className={className} ref={setLabelRefs}>
      <ListItemContent
        {...contentProps}
        suffix={
          <MainToggle
            /**
             * {@link CommonListItemAPI}'s `label` prop is required, so we can safely mark this toggle as having an accessible
             * label.
             */
            hasAccessibleLabel
            name={name}
            value={!!checked}
            {...rest}
          />
        }
      />
    </label>
  );
};

ListItemToggle.displayName = 'ListItemToggle';

export default ListItemToggle;
